/**
 * 書式 ID から FormatDefinition を解決する（Vue 非依存）。
 * 検索順は旧 get-format-by-id.js と同じ（先勝ち）。
 * letter_index は旧実装同様に含めない（site.js との不整合は既知）。
 */
import etcFormatsIndex from '@/assets/formats/etc_index'
import formatsIndex from '@/assets/formats/index'
import keirekishoFormatsIndex from '@/assets/formats/keirekisho_index'
import rirekishoFormatsIndex from '@/assets/formats/rirekisho_index'
import yagiofferFormatsIndex from '@/assets/formats/yagioffer_index'
import type { FormatDefinition } from '@/utils/format-edit/formatDefinition'

const FORMAT_REGISTRIES: FormatDefinition[][] = [
  formatsIndex as unknown as FormatDefinition[],
  keirekishoFormatsIndex as unknown as FormatDefinition[],
  rirekishoFormatsIndex as unknown as FormatDefinition[],
  yagiofferFormatsIndex as unknown as FormatDefinition[],
  etcFormatsIndex as unknown as FormatDefinition[]
]

export function getFormatById(id: string): FormatDefinition | undefined {
  for (const registry of FORMAT_REGISTRIES) {
    const found = registry.find((format) => format.id === id)
    if (found) return found
  }
  return undefined
}
